import SquaresGrid from './SquaresGrid'

export default SquaresGrid
